var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3CE6E",
    d: "M32.914 24.703c-3.97 6.03-13.67 6.892-21.609 1.867C3.368 21.544.134 12.498 4.103 6.468 8.07.438 17.773-.424 25.71 4.601c7.938 5.026 11.172 14.072 7.203 20.102Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M32.914 24.56c-4.41 5.026-13.376 5.457-20.873.718-7.644-4.881-10.878-13.21-7.644-19.24-.735 1.149-2.058 3.16-2.205 3.446-3.674 5.6-.294 14.071 7.791 19.097 7.938 5.025 17.346 4.594 21.02-.862.147-.287 1.323-1.866 2.058-3.159h-.147Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M4.103 6.47c-3.969 6.03-.882 15.075 7.203 20.1 7.938 5.026 17.64 4.164 21.608-1.866 0 0-.294.43-.588 1.005.441-.718.882-1.292.882-1.436-3.968 6.03-13.67 6.892-21.608 1.867C3.662 21.114.428 12.069 4.397 6.038c0 0-.44.718-1.029 1.436l.588-.861.147-.144Z",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M33.061 24.56c-.735 1.148-1.764 2.584-1.91 2.727-3.675 5.6-13.083 5.887-21.02.862-7.939-5.025-11.466-13.64-7.792-19.096 0-.288 1.176-1.723 1.911-2.872C3.515 7.33 2.34 9.196 2.192 9.34c-3.674 5.6-.294 14.07 7.791 19.096 7.938 5.025 17.346 4.595 21.02-.861.147-.288 1.323-1.867 2.058-3.16v.144Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M33.208 24.13c-3.969 6.03-13.67 6.891-21.608 1.866C3.662 20.97.428 11.925 4.397 5.894c3.97-6.03 13.67-6.892 21.609-1.866 7.937 5.025 11.171 14.07 7.202 20.101Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M33.209 24.129c-3.97 6.03-13.67 6.748-21.609 1.723C3.663 20.826.43 11.924 4.545 5.894c3.968-6.03 13.67-6.748 21.608-1.723C34.09 9.196 37.325 18.1 33.209 24.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M33.21 24.129c-3.97 6.03-13.671 6.748-21.462 1.723C3.81 20.826.723 11.924 4.692 5.894c3.97-6.03 13.67-6.748 21.462-1.723C34.09 9.196 37.178 18.1 33.209 24.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M33.062 24.129c-3.969 6.03-13.524 6.748-21.461 1.723C3.663 20.827.576 11.925 4.545 6.038 8.514.008 18.068-.711 26.006 4.315c7.938 5.025 11.025 13.927 7.056 19.814Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M33.062 23.985c-3.969 5.887-13.524 6.749-21.314 1.723C3.957 20.683.723 11.925 4.692 5.894 8.66.007 18.215-.854 26.006 4.171c7.79 5.025 11.025 13.784 7.056 19.814Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M33.062 23.986c-3.969 5.886-13.524 6.748-21.314 1.723C3.957 20.683.723 11.925 4.692 6.038 8.66.15 18.215-.71 26.006 4.315c7.79 5.025 11.025 13.784 7.056 19.67Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M32.914 23.986c-3.968 5.886-13.376 6.748-21.167 1.723C3.957 20.827.87 11.925 4.691 6.038 8.661.15 18.068-.71 25.86 4.315c7.79 4.882 10.877 13.784 7.055 19.67Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M32.914 23.986c-3.968 5.887-13.376 6.748-21.167 1.723C3.957 20.827.87 12.069 4.838 6.182 8.808.295 18.215-.567 26.006 4.459c7.79 4.882 10.877 13.64 6.908 19.527Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M32.915 23.985c-3.969 5.887-13.376 6.605-21.02 1.723-7.79-4.881-10.878-13.64-6.909-19.527C8.955.294 18.363-.424 26.006 4.458c7.791 4.882 10.878 13.64 6.91 19.527Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M32.915 23.842c-3.822 5.887-13.376 6.605-21.02 1.723-7.79-4.882-10.878-13.64-6.909-19.527C8.808.15 18.363-.567 26.006 4.315c7.644 4.881 10.878 13.64 6.91 19.527Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M32.768 23.842c-3.822 5.887-13.23 6.605-21.02 1.723C4.104 20.683 1.017 12.068 4.838 6.18 8.662.294 18.069-.424 25.86 4.458c7.644 4.882 10.73 13.497 6.909 19.384Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M32.767 23.842c-3.822 5.887-13.23 6.605-20.873 1.723C4.25 20.683 1.164 12.068 4.985 6.18 8.807.294 18.215-.424 25.86 4.458c7.643 4.882 10.73 13.497 6.908 19.384Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M32.767 23.842c-3.822 5.744-13.23 6.605-20.873 1.723C4.25 20.683 1.164 12.07 4.985 6.325 8.807.582 18.215-.279 25.86 4.602c7.643 4.882 10.73 13.497 6.908 19.24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M32.62 23.842c-3.822 5.744-13.082 6.605-20.726 1.723C4.25 20.683 1.164 12.07 5.132 6.325 8.954.582 18.215-.279 25.858 4.602 33.502 9.484 36.59 18.1 32.62 23.842Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M32.62 23.698c-3.821 5.743-13.082 6.461-20.726 1.723C4.251 20.539 1.311 12.068 5.133 6.325 8.954.58 18.215-.137 25.859 4.602c7.644 4.881 10.584 13.353 6.762 19.096Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M32.62 23.698c-3.821 5.743-13.082 6.461-20.579 1.723S1.458 12.068 5.28 6.325C9.101.58 18.362-.137 25.86 4.602c7.496 4.738 10.583 13.353 6.761 19.096Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M32.473 23.698c-3.822 5.743-12.935 6.461-20.579 1.723C4.397 20.683 1.31 12.068 5.132 6.468 8.954.725 18.068.008 25.712 4.745c7.496 4.738 10.583 13.353 6.761 18.953Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M32.474 23.698c-3.822 5.743-12.936 6.461-20.433 1.723S1.458 12.211 5.28 6.468C9.101.725 18.215.008 25.712 4.745c7.497 4.738 10.583 13.21 6.762 18.953Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M32.474 23.698c-3.822 5.743-12.936 6.461-20.433 1.723C4.545 20.683 1.605 12.211 5.28 6.468 9.1.725 18.215.008 25.712 4.745c7.497 4.738 10.437 13.21 6.762 18.953Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M32.327 23.554c-3.822 5.6-12.936 6.461-20.286 1.723C4.545 20.54 1.605 12.067 5.28 6.468 9.1.868 18.215.007 25.565 4.745c7.497 4.738 10.437 13.21 6.762 18.81Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M32.327 23.554c-3.822 5.6-12.789 6.461-20.285 1.723C4.545 20.54 1.605 12.211 5.427 6.468 9.249.868 18.215.007 25.712 4.745s10.437 13.066 6.615 18.81Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M32.327 23.554c-3.675 5.6-12.79 6.318-20.139 1.723C4.838 20.54 1.752 12.211 5.573 6.612c3.675-5.6 12.789-6.318 20.139-1.723 7.35 4.738 10.436 13.066 6.615 18.665Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M32.18 23.554c-3.675 5.6-12.79 6.318-20.139 1.723-7.35-4.738-10.29-13.066-6.615-18.665 3.675-5.6 12.789-6.318 20.139-1.723 7.35 4.738 10.29 13.066 6.614 18.665Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M32.18 23.555c-3.676 5.6-12.642 6.317-19.992 1.722-7.35-4.738-10.29-12.922-6.615-18.522 3.675-5.6 12.642-6.317 19.991-1.723 7.35 4.739 10.29 12.923 6.615 18.523Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M32.18 23.41c-3.676 5.6-12.642 6.318-19.992 1.724-7.35-4.595-10.29-12.923-6.615-18.522 3.675-5.6 12.642-6.318 19.991-1.723 7.35 4.594 10.29 12.922 6.615 18.522Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M32.18 23.41c-3.675 5.6-12.642 6.319-19.845 1.724-7.35-4.595-10.29-12.923-6.614-18.379 3.675-5.6 12.641-6.317 19.844-1.723 7.35 4.595 10.29 12.923 6.615 18.379Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M32.033 23.411c-3.675 5.6-12.495 6.318-19.845 1.58C4.838 20.396 2.046 12.21 5.72 6.612c3.675-5.6 12.495-6.317 19.845-1.58 7.35 4.595 10.143 12.78 6.468 18.38Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M32.033 23.41c-3.675 5.457-12.495 6.318-19.845 1.58C4.838 20.395 2.046 12.211 5.72 6.612 9.396 1.155 18.215.294 25.566 5.032c7.35 4.595 10.143 12.779 6.468 18.379Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M32.033 23.41c-3.675 5.457-12.495 6.318-19.845 1.58C4.986 20.395 2.046 12.211 5.721 6.612 9.395 1.155 18.215.294 25.565 5.032c7.203 4.595 10.143 12.779 6.468 18.379Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M32.033 23.41c-3.675 5.457-12.495 6.318-19.845 1.58C4.986 20.395 2.046 12.211 5.721 6.612 9.395 1.155 18.215.294 25.565 5.032c7.203 4.595 10.143 12.779 6.468 18.379Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M32.033 23.41c-3.675 5.457-12.495 6.318-19.845 1.58C4.986 20.395 2.046 12.211 5.721 6.612 9.395 1.155 18.215.294 25.565 5.032c7.203 4.595 10.143 12.779 6.468 18.379Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.379v-.144Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.235Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.235Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.235Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.235Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M32.033 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C5.133 20.396 2.194 12.21 5.869 6.756 9.543 1.3 18.362.582 25.565 5.176c7.203 4.595 10.143 12.78 6.468 18.235Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M31.886 23.411c-3.675 5.456-12.495 6.174-19.698 1.58C4.986 20.396 2.046 12.21 5.721 6.756 9.395 1.3 18.215.582 25.418 5.176c7.203 4.595 10.142 12.78 6.468 18.235Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M31.886 23.268c-3.675 5.456-12.495 6.174-19.698 1.579C4.986 20.252 2.046 12.068 5.721 6.612 9.395 1.156 18.215.438 25.418 5.032c7.203 4.595 10.142 12.78 6.468 18.236Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M31.886 23.268c-3.675 5.456-12.495 6.174-19.698 1.579C4.986 20.252 2.046 12.068 5.721 6.612 9.395 1.156 18.215.438 25.418 5.032c7.203 4.595 10.142 12.78 6.468 18.236Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M31.886 23.268c-3.675 5.456-12.495 6.174-19.698 1.579C4.986 20.252 2.046 12.212 5.721 6.612 9.395 1.156 18.215.438 25.418 5.032c7.203 4.595 10.142 12.636 6.468 18.236Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M31.886 23.268c-3.675 5.456-12.348 6.174-19.55 1.58C5.132 20.252 2.192 12.211 5.867 6.755 9.543 1.3 18.215.582 25.418 5.176c7.203 4.595 10.143 12.636 6.468 18.092Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M31.886 23.268c-3.675 5.456-12.348 6.174-19.55 1.58C5.132 20.252 2.192 12.211 5.867 6.755 9.543 1.3 18.215.582 25.418 5.176c7.203 4.595 10.143 12.636 6.468 18.092Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M31.886 23.268c-3.675 5.456-12.348 6.174-19.55 1.58C5.132 20.252 2.192 12.211 5.867 6.755 9.543 1.3 18.215.582 25.418 5.176c7.203 4.595 10.143 12.636 6.468 18.092Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M31.885 23.268c-3.675 5.456-12.347 6.174-19.55 1.58-7.203-4.595-9.996-12.636-6.468-18.092C9.542 1.3 18.215.582 25.417 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M31.886 23.268c-3.675 5.456-12.348 6.174-19.404 1.58C5.28 20.252 2.487 12.211 6.015 6.755 9.689 1.3 18.362.582 25.418 5.176c7.203 4.595 9.996 12.636 6.468 18.092Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M31.738 23.268c-3.675 5.456-12.347 6.174-19.403 1.58-7.203-4.595-9.996-12.636-6.468-17.949C9.395 1.443 18.215.725 25.271 5.32c7.202 4.595 9.995 12.635 6.467 17.948Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M31.738 23.268c-3.528 5.456-12.347 6.174-19.403 1.58-7.203-4.595-9.996-12.636-6.468-17.949C9.395 1.443 18.215.725 25.271 5.32c7.202 4.595 9.995 12.635 6.467 17.948Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M31.739 23.268c-3.528 5.456-12.348 6.174-19.404 1.58C5.28 20.395 2.34 12.211 5.867 6.898 9.395 1.443 18.215.725 25.271 5.32c7.056 4.451 9.995 12.635 6.468 17.948Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M31.739 23.268c-3.528 5.456-12.348 6.174-19.404 1.58C5.28 20.395 2.34 12.355 6.015 6.898 9.542 1.443 18.362.725 25.418 5.32c7.056 4.451 9.996 12.492 6.32 17.948Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M31.739 23.268c-3.528 5.456-12.2 6.174-19.404 1.58C5.28 20.395 2.34 12.355 6.015 6.898 9.542 1.443 18.215.725 25.418 5.32c7.056 4.451 9.996 12.492 6.32 17.948Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M31.739 23.268c-3.528 5.456-12.2 6.174-19.404 1.58C5.28 20.395 2.34 12.355 6.015 6.898 9.542 1.443 18.215.725 25.418 5.32c7.056 4.451 9.996 12.492 6.32 17.948Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M31.739 23.268c-3.528 5.456-12.2 6.174-19.404 1.58C5.28 20.395 2.34 12.355 6.015 6.898 9.542 1.443 18.215.725 25.418 5.32c7.056 4.451 9.996 12.492 6.32 17.948Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M31.739 23.124c-3.528 5.312-12.2 6.03-19.256 1.579-7.056-4.451-9.996-12.492-6.321-17.948C9.69 1.443 18.362.581 25.418 5.176c7.056 4.451 9.996 12.492 6.32 17.948Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M31.739 23.124c-3.528 5.312-12.2 6.03-19.256 1.58-7.056-4.452-9.996-12.492-6.321-17.805C9.69 1.587 18.362.87 25.418 5.32c7.056 4.452 9.996 12.492 6.32 17.805Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M31.738 23.124c-3.527 5.312-12.2 6.03-19.256 1.58-7.056-4.452-9.849-12.492-6.32-17.805 3.527-5.312 12.2-6.03 19.256-1.58 7.056 4.452 9.848 12.492 6.32 17.805Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M31.738 23.124c-3.527 5.312-12.2 6.03-19.256 1.58-7.056-4.452-9.849-12.492-6.32-17.805 3.527-5.312 12.2-6.03 19.256-1.58 7.056 4.452 9.848 12.492 6.32 17.805Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M31.592 23.124c-3.528 5.312-12.2 6.03-19.257 1.58-7.055-4.452-9.848-12.492-6.32-17.805C9.543 1.587 18.215.87 25.27 5.32c7.056 4.452 9.849 12.492 6.32 17.805Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M31.592 23.124c-3.528 5.312-12.2 6.03-19.257 1.58-7.055-4.452-9.848-12.492-6.32-17.805C9.543 1.587 18.215.87 25.27 5.32c7.056 4.452 9.849 12.492 6.32 17.805Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M31.592 23.124c-3.528 5.312-12.2 6.03-19.257 1.58-7.055-4.452-9.848-12.492-6.32-17.805C9.543 1.587 18.215.87 25.27 5.32c7.056 4.452 9.849 12.492 6.32 17.805Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M31.591 23.124c-3.527 5.312-12.2 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.805C9.688 1.587 18.361.87 25.27 5.32c7.056 4.452 9.848 12.349 6.32 17.805Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M31.591 23.124c-3.527 5.312-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.805C9.688 1.587 18.214.87 25.27 5.32c7.056 4.452 9.848 12.349 6.32 17.805Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.661 3.527-5.313 12.053-6.03 19.109-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.661 3.527-5.313 12.053-6.03 19.109-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.661 3.527-5.313 12.053-6.03 19.109-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.661 3.527-5.313 12.053-6.03 19.109-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-19.109 1.58-7.056-4.452-9.849-12.349-6.32-17.661 3.527-5.313 12.053-6.03 19.109-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M31.591 23.124c-3.527 5.313-12.053 6.03-18.962 1.58C5.573 20.251 2.78 12.354 6.31 7.042c3.527-5.313 12.053-6.03 18.962-1.58 7.056 4.451 9.848 12.348 6.32 17.661Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M31.444 23.124c-3.528 5.313-12.054 6.03-18.962 1.58-6.91-4.452-9.85-12.349-6.321-17.661 3.528-5.313 12.053-6.03 18.962-1.58 6.909 4.451 9.849 12.348 6.32 17.661Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M31.444 22.98c-3.528 5.313-12.053 6.03-18.962 1.58-6.909-4.451-9.702-12.348-6.32-17.517 3.527-5.313 12.053-6.03 18.961-1.58 6.91 4.451 9.702 12.348 6.321 17.517Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M31.444 22.98c-3.528 5.313-12.053 6.03-18.962 1.58-6.909-4.451-9.702-12.348-6.32-17.517 3.527-5.313 12.053-6.03 18.961-1.58 6.91 4.451 9.702 12.348 6.321 17.517Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M31.445 22.98c-3.528 5.313-12.054 6.03-18.963 1.58C5.574 20.109 2.781 12.355 6.31 7.043c3.528-5.313 12.053-6.03 18.962-1.58 6.909 4.451 9.702 12.205 6.174 17.517Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M31.445 22.98c-3.528 5.313-11.907 6.03-18.963 1.58C5.574 20.109 2.781 12.355 6.31 7.043c3.528-5.313 11.906-6.03 18.962-1.58 6.909 4.451 9.702 12.205 6.174 17.517Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M31.445 22.98c-3.528 5.313-11.907 6.03-18.963 1.58C5.574 20.109 2.781 12.355 6.31 7.043c3.528-5.313 11.906-6.03 18.962-1.58 6.909 4.451 9.702 12.205 6.174 17.517Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M31.445 22.98c-3.528 5.313-11.907 6.03-18.816 1.58C5.72 20.109 2.927 12.355 6.455 7.043c3.528-5.313 11.907-6.03 18.816-1.58 6.908 4.451 9.701 12.205 6.174 17.517Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M31.445 22.98c-3.528 5.313-11.907 5.887-18.816 1.58C5.72 20.107 2.927 12.354 6.455 7.185c3.528-5.313 11.907-5.887 18.816-1.58 6.908 4.452 9.701 12.205 6.174 17.374Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M31.298 22.98c-3.528 5.17-11.907 5.887-18.816 1.58C5.574 20.252 2.781 12.355 6.31 7.186 9.837 2.017 18.215 1.3 25.124 5.606c6.909 4.308 9.702 12.205 6.174 17.374Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M31.297 22.98c-3.527 5.17-11.906 5.887-18.668 1.58C5.72 20.252 2.927 12.499 6.455 7.186 9.983 2.017 18.362 1.3 25.124 5.606c6.909 4.308 9.701 12.062 6.174 17.374Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M31.298 22.98c-3.528 5.17-11.76 5.887-18.669 1.58C5.72 20.252 3.075 12.499 6.455 7.186c3.528-5.169 11.76-5.887 18.669-1.58 6.909 4.308 9.555 12.062 6.174 17.374Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M31.298 22.837c-3.381 5.169-11.76 5.887-18.669 1.58-6.909-4.308-9.554-12.062-6.174-17.23 3.381-5.17 11.76-5.888 18.669-1.58 6.909 4.307 9.555 12.06 6.174 17.23Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M31.298 22.837c-3.381 5.169-11.76 5.887-18.669 1.58-6.761-4.308-9.554-12.062-6.173-17.23 3.38-5.17 11.76-5.888 18.668-1.58 6.762 4.307 9.555 12.06 6.174 17.23Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M31.15 22.837c-3.38 5.169-11.759 5.887-18.52 1.58-6.762-4.308-9.555-12.062-6.174-17.23 3.38-5.17 11.76-5.888 18.521-1.58 6.762 4.307 9.555 12.06 6.174 17.23Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M31.15 22.836c-3.38 5.17-11.759 5.887-18.52 1.58-6.763-4.308-9.555-11.918-6.028-17.087C9.983 2.16 18.362 1.443 25.124 5.75c6.762 4.307 9.555 11.917 6.027 17.086Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M31.15 22.836c-3.38 5.17-11.759 5.887-18.52 1.58-6.763-4.308-9.555-11.918-6.028-17.087C9.983 2.16 18.362 1.443 25.124 5.75c6.762 4.307 9.555 11.917 6.027 17.086Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M31.15 22.836c-3.38 5.17-11.612 5.887-18.374 1.58C6.015 20.108 3.222 12.498 6.75 7.329 10.13 2.16 18.362 1.443 25.124 5.75c6.762 4.307 9.555 11.917 6.027 17.086Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M31.15 22.836c-3.38 5.17-11.612 5.744-18.374 1.58C6.014 20.108 3.37 12.498 6.75 7.33c3.381-5.17 11.613-5.744 18.375-1.58 6.762 4.308 9.408 11.918 6.027 17.086Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M31.003 22.837c-3.38 5.169-11.612 5.743-18.374 1.58-6.762-4.308-9.408-11.918-6.027-16.943 3.381-5.17 11.613-5.744 18.375-1.58 6.761 4.308 9.407 11.917 6.026 16.943Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M31.004 22.693c-3.381 5.169-11.613 5.743-18.228 1.58C6.014 19.964 3.37 12.498 6.75 7.33c3.381-5.17 11.613-5.744 18.228-1.58 6.762 4.308 9.408 11.774 6.027 16.943Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M31.004 22.693c-3.381 5.026-11.613 5.744-18.228 1.58C6.014 19.965 3.37 12.499 6.75 7.33c3.381-5.025 11.613-5.743 18.228-1.58 6.762 4.308 9.408 11.774 6.027 16.943Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M31.004 22.693c-3.381 5.025-11.466 5.743-18.228 1.58-6.614-4.308-9.407-11.774-6.026-16.8 3.38-5.025 11.465-5.743 18.227-1.58 6.615 4.308 9.408 11.775 6.027 16.8Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M31.004 22.693c-3.381 5.025-11.466 5.743-18.228 1.58-6.614-4.165-9.407-11.774-6.026-16.8 3.38-5.025 11.465-5.743 18.227-1.58 6.615 4.165 9.408 11.775 6.027 16.8Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M30.856 22.693c-3.38 5.025-11.465 5.743-18.08 1.436-6.615-4.164-9.26-11.774-6.027-16.8 3.381-5.025 11.466-5.742 18.08-1.435 6.615 4.164 9.261 11.774 6.027 16.8Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M30.856 22.693c-3.38 5.025-11.465 5.743-18.08 1.436-6.615-4.164-9.26-11.63-6.027-16.8 3.381-5.025 11.466-5.742 18.08-1.435 6.615 4.164 9.261 11.63 6.027 16.8Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M30.857 22.693c-3.381 5.025-11.466 5.743-18.08 1.436-6.615-4.164-9.261-11.63-5.88-16.655 3.38-5.026 11.465-5.744 18.08-1.436 6.615 4.164 9.26 11.63 5.88 16.655Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M30.856 22.693c-3.38 5.025-11.318 5.743-17.933 1.436-6.615-4.164-9.26-11.63-5.88-16.655 3.381-5.026 11.319-5.744 17.934-1.436 6.614 4.164 9.26 11.63 5.88 16.655Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M30.856 22.55c-3.38 5.025-11.318 5.6-17.933 1.436s-9.26-11.63-5.88-16.656c3.381-5.025 11.319-5.6 17.934-1.436 6.614 4.164 9.26 11.63 5.88 16.656Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M30.71 22.55c-3.381 5.025-11.319 5.6-17.934 1.436-6.614-4.164-9.26-11.63-5.88-16.512 3.381-5.025 11.32-5.6 17.934-1.436 6.615 4.164 9.26 11.63 5.88 16.512Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M30.71 22.55c-3.234 5.025-11.32 5.6-17.787 1.436-6.615-4.164-9.26-11.63-5.88-16.512 3.234-5.025 11.319-5.6 17.787-1.436 6.614 4.164 9.26 11.63 5.88 16.512Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M30.71 22.55c-3.235 5.025-11.32 5.6-17.787 1.436-6.468-4.164-9.114-11.487-5.88-16.512 3.234-5.025 11.319-5.6 17.786-1.436 6.468 4.164 9.114 11.487 5.88 16.512Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD73F",
    d: "M30.71 22.55c-3.235 4.881-11.32 5.6-17.787 1.435C6.455 19.822 3.809 12.5 7.043 7.474c3.234-4.882 11.319-5.6 17.786-1.436 6.468 4.163 9.114 11.486 5.88 16.512Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A25A00",
    style: {
      mixBlendMode: "screen"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M13.07 1.012c-2.352.287-4.557 1.149-6.32 2.585l4.85 22.255c2.352 1.58 4.998 2.44 7.497 3.015L13.07.869v.143ZM16.745.869h-1.029l6.174 28.429h1.03L16.744.868ZM4.839 5.32s-.294.43-.441.574C.87 11.206 2.928 18.816 8.955 23.985L4.839 5.32ZM32.62 24.99s.441-.574.588-.86c3.528-5.457 1.47-13.21-4.85-18.38l4.115 19.24h.147ZM24.242 29.154c2.793-.287 5.439-1.292 7.35-3.159L26.888 4.602s-.588-.431-.882-.575a21.543 21.543 0 0 0-7.938-3.015l6.174 28.142Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M22.183 31.738c-1.175 1.867-3.821 2.44-5.732 1.149-1.911-1.149-2.5-3.733-1.176-5.6 1.176-1.866 3.822-2.44 5.733-1.148 1.91 1.149 2.498 3.733 1.175 5.6Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -7.944,
    x2: 20.458,
    y1: 6.394,
    y2: 25.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EFBE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDB938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DE972C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D68225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D37B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DA8F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBC017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F6DE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -7.204,
    x2: 21.197,
    y1: 5.281,
    y2: 24.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#DA901C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B8720F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A35F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9C5905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A46714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CBA657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E7D489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F8F1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69F49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.523,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.522,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.522,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.522,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.522,
    x2: 28.998,
    y1: 16.281,
    y2: -5.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.523,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.523,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.522,
    x2: 28.999,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.522,
    x2: 28.998,
    y1: 16.28,
    y2: -5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 0.522,
    x2: 28.897,
    y1: 16.28,
    y2: -5.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 0.685,
    x2: 28.191,
    y1: 16.383,
    y2: -5.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED75D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 0.848,
    x2: 27.652,
    y1: 16.486,
    y2: -5.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 1.01,
    x2: 27.112,
    y1: 16.589,
    y2: -4.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDE96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCD95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 1.173,
    x2: 26.675,
    y1: 16.692,
    y2: -4.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FDE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBD85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCF55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 1.279,
    x2: 25.978,
    y1: 16.534,
    y2: -4.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACD53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 1.442,
    x2: 25.44,
    y1: 16.637,
    y2: -4.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9CA50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 1.604,
    x2: 24.901,
    y1: 16.741,
    y2: -4.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C84E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 1.767,
    x2: 24.529,
    y1: 16.844,
    y2: -4.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FAD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C54C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 1.93,
    x2: 23.992,
    y1: 16.947,
    y2: -4.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9D355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 2.093,
    x2: 23.455,
    y1: 17.05,
    y2: -4.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9D254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 2.255,
    x2: 22.919,
    y1: 17.153,
    y2: -4.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE15D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F8D152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 2.418,
    x2: 22.383,
    y1: 17.256,
    y2: -3.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F8D050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BB42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 2.581,
    x2: 22.012,
    y1: 17.36,
    y2: -3.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 2.744,
    x2: 21.477,
    y1: 17.463,
    y2: -3.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CD4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B73D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 2.906,
    x2: 21.107,
    y1: 17.566,
    y2: -3.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8CC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B43B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 3.175,
    x2: 20.577,
    y1: 17.51,
    y2: -3.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7CB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 3.338,
    x2: 20.208,
    y1: 17.613,
    y2: -2.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDDA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7CA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EEB137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAF36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 3.337,
    x2: 19.839,
    y1: 17.613,
    y2: -2.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7C944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EEB034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 3.5,
    x2: 19.307,
    y1: 17.717,
    y2: -2.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDAF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 3.663,
    x2: 18.939,
    y1: 17.82,
    y2: -2.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EDAE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 3.825,
    x2: 18.571,
    y1: 17.923,
    y2: -2.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDAD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA52C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 3.988,
    x2: 18.204,
    y1: 18.026,
    y2: -1.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ECAC2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A32A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 4.256,
    x2: 17.841,
    y1: 17.971,
    y2: -1.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C43A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ECAB2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 4.42,
    x2: 17.475,
    y1: 18.074,
    y2: -1.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBAA2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 4.419,
    x2: 17.108,
    y1: 18.074,
    y2: -1.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 4.582,
    x2: 16.743,
    y1: 18.177,
    y2: -1.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 4.583,
    x2: 16.743,
    y1: 18.176,
    y2: -1.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 4.688,
    x2: 16.747,
    y1: 18.018,
    y2: -0.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 4.688,
    x2: 16.746,
    y1: 18.018,
    y2: -0.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 4.688,
    x2: 16.644,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 4.687,
    x2: 16.643,
    y1: 18.018,
    y2: -0.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 4.793,
    x2: 16.647,
    y1: 17.859,
    y2: -0.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 4.793,
    x2: 16.647,
    y1: 17.859,
    y2: -0.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 4.794,
    x2: 16.648,
    y1: 17.859,
    y2: -0.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 4.794,
    x2: 16.546,
    y1: 17.859,
    y2: -0.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 4.794,
    x2: 16.546,
    y1: 17.859,
    y2: -0.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: -0.247,
    x2: 11.227,
    y1: 13.143,
    y2: -5.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 27.694,
    x2: 38.865,
    y1: 37.899,
    y2: 18.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 19.888,
    x2: 30.749,
    y1: 31.151,
    y2: 12.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 11.397,
    x2: 21.844,
    y1: 23.374,
    y2: 4.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 2.136,
    x2: 12.239,
    y1: 14.743,
    y2: -4.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 22.478,
    x2: 32.301,
    y1: 32.716,
    y2: 13.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 10.855,
    x2: 20.227,
    y1: 22.696,
    y2: 3.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 27.374,
    x2: 36.428,
    y1: 36.962,
    y2: 16.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 14.061,
    x2: 22.64,
    y1: 24.974,
    y2: 4.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAE2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 26.837,
    x2: 35.062,
    y1: 35.907,
    y2: 15.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 12.157,
    x2: 19.884,
    y1: 22.703,
    y2: 2.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B32D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 20.982,
    x2: 28.324,
    y1: 30.973,
    y2: 10.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B62E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 6.063,
    x2: 12.883,
    y1: 16.423,
    y2: -4.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 12.278,
    x2: 18.725,
    y1: 22.374,
    y2: 1.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 16.756,
    x2: 22.716,
    y1: 26.367,
    y2: 5.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BD32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 19.515,
    x2: 25.017,
    y1: 29.047,
    y2: 7.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 20.976,
    x2: 25.998,
    y1: 30.097,
    y2: 8.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 21.24,
    x2: 25.733,
    y1: 30.172,
    y2: 8.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 20.457,
    x2: 24.44,
    y1: 29.382,
    y2: 7.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 19.001,
    x2: 22.456,
    y1: 27.707,
    y2: 5.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 17.125,
    x2: 20.019,
    y1: 25.771,
    y2: 3.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACB39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 14.996,
    x2: 17.353,
    y1: 23.677,
    y2: 1.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 21.169,
    x2: 22.947,
    y1: 29.447,
    y2: 7.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FCD13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 12.088,
    x2: 13.272,
    y1: 19.766,
    y2: -2.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 16.468,
    x2: 17.067,
    y1: 24.065,
    y2: 1.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED53E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(32.375 -34.275 30.18) scale(4.04673 4.00709)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBack);
export default __webpack_public_path__ + "static/media/coin-back.d8f0a78bcbf2d8af7f681ed16a10dafc.svg";
export { ForwardRef as ReactComponent };